module.exports = __webpack_public_path__ + "static/img/com1_2.1c89c47.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/com1_2.jpg
// module id = Vz7X
// module chunks = 1